import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { FlexColumn, FlexRow } from '../atoms/layout/Flex'
import List from '../atoms/display/List'
import ListItem from '../atoms/display/ListItem'
import usePath from '../../hooks/usePath'
import Divider from '../atoms/display/Divider'
import { ClientIcon, CompanyIcon, SubcontractorIcon, SurveyIcon, WorkerIcon } from '../atoms/display/Icons'
import usePage from '../../hooks/usePage'

export default function VisitorRegistrationLayout() {
  const path = usePath()
  const { pathname } = useLocation()
  const { changeTitle } = usePage()

  useEffect(() => {
    changeTitle('新規入場者調査票')
  }, [changeTitle])

  return (
    <FlexRow>
      <FlexColumn width={240}>
        <List>
          <ListItem
            label="取引先"
            icon={<ClientIcon />}
            selected={pathname === path.visitorRegistration()}
            href={path.visitorRegistration()}
          />
          <Divider />
          <ListItem
            label="事業者情報"
            icon={<CompanyIcon />}
            selected={pathname === path.visitorRegistrationCompany()}
            href={path.visitorRegistrationCompany()}
          />
          <Divider />
          <ListItem
            label="アンケート"
            icon={<SurveyIcon />}
            selected={pathname === path.visitorRegistrationAnswers()}
            href={path.visitorRegistrationAnswers()}
          />
          <Divider />
          <ListItem
            label="労働者一覧"
            icon={<WorkerIcon />}
            selected={pathname === path.visitorRegistrationWorkers()}
            href={path.visitorRegistrationWorkers()}
          />
          <Divider />
          <ListItem
            label="下請け一覧"
            icon={<SubcontractorIcon />}
            selected={pathname === path.visitorRegistrationSubcontractors()}
            href={path.visitorRegistrationSubcontractors()}
          />
        </List>
      </FlexColumn>
      <Outlet />
    </FlexRow>
  )
}
